<template>
    <div>
        <ul class="newsList">
            <li v-for="(item,index) in newsList" v-if="index < newsLength" @click="goPageBtn(index+1)">
                <div class="newsListTitle">{{item.title}}</div>
                <div class="newsListText">
                    {{item.content}}
                </div>
                <div class="newsListImg"><img :src="item.icon" alt=""></div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { articlesList } from '../json/articles';
    export default {
        name:'newsList',
        data() {
            return {
                newsList: articlesList,
            }
        },
        props:{
            newsLength:{
                type: Number,
                default: 50,
            }
        },
        methods:{
            // 跳转详情
            goPageBtn(id){
                this.$router.push(`/articles/${id}`)
            },
        },
    }
</script>

<style lang="scss" scoped>
    .newsList{
        li{
            cursor: pointer;
            padding:35px 0;
            position: relative;
            padding-right:260px;
            transition: margin 0.3s;
            @include h-border(1px solid var(--colorE8),bottom);
            &:last-child{
                border-bottom:none;
            }
            .newsListTitle{
                font-weight: bold;
                user-select: text;
                transition: color 0.3s;
                @include h-fontSize(var(--color22),20px,34px);
            }
            .newsListText{
                margin:14px 0 0;
                user-select: text;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                @include h-fontSize($color66,15px,26px);
            }
            .newsListImg{
                top:36px;
                right:0;
                width:240px;
                height:130px;
                overflow: hidden;
                position: absolute;
                img{
                    height: 100%;
                    object-fit: cover;
                }
            }
            &:hover{
                .newsListTitle{
                    color:$colorE7;
                }
            }
        }

    }
</style>